import React from 'react';
import { useStyletron } from 'baseui';
import { getProjectDetail } from '@gtintel/platform-api';
import { addMemberToProject, deleteMemberFromProject } from '@gtintel/platform-api';
import { AbsoluteLoading } from '@gtintel/platform-atoms';
import { useStores } from '@gtintel/platform-stores';
import { LegacyProjectDetailPartners } from './Partners';
import ProjectActivityFeed from './ProjectActivityFeed';
import ProjectMembers, { ProjectPartner } from './ProjectMembers';
import Reports from './Reports';
const LegacyComponentContainer = ({
  children
}) => {
  const [css] = useStyletron();
  const hatched = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cline x1='0' y1='10' x2='10' y2='0' stroke='%23ffddaa' stroke-width='1'/%3E%3C/svg%3E")`,
    backgroundSize: '10px 10px',
    backgroundRepeat: 'repeat'
  };
  return <div className={css({
    margin: '1em',
    padding: '2em 3em',
    ...hatched,
    border: 'solid 4px rgba(255,186,0,0.1)'
  })}>
      {children}
    </div>;
};
export const LegacyActivityFeed = ({
  id
}) => {
  const [project, setProject] = React.useState(null);
  React.useEffect(() => {
    getProjectDetail(`${id}`).then(res => {
      const project = {
        ...res,
        statusDetail: res.status,
        typeBatch: res.source
      };
      setProject(project);
    }).catch(console.error);
  }, [id]);
  if (!project) return null;
  return <LegacyComponentContainer>
      <ProjectActivityFeed project={project} />
    </LegacyComponentContainer>;
};
export const LegacyMembers = ({
  id
}) => {
  const [project, setProject] = React.useState(null);
  const [loadingState, setLoadingState] = React.useState(false);
  React.useEffect(() => {
    getProjectDetail(`${id}`).then(res => {
      const project = {
        ...res,
        statusDetail: res.status,
        typeBatch: res.source
      };
      setProject(project);
    }).catch(console.error);
  }, [id]);
  if (!project) return null;
  return <LegacyComponentContainer>
      <AbsoluteLoading isLoading={loadingState} />
      <ProjectMembers project={project} onRemoveMemberFromProject={async (projectId, memberId) => {
      try {
        setLoadingState(true);
        await deleteMemberFromProject({
          projectId,
          memberId
        }).then(res => {
          setProject(res);
          setLoadingState(false);
        });
      } catch (error) {
        setLoadingState(false);
      }
    }} onAddMemberToProject={async (data, projectId) => {
      try {
        setLoadingState(true);
        await addMemberToProject({
          data,
          projectId
        }).then(res => {
          setProject(res);
          setLoadingState(false);
        });
      } catch (error) {
        setLoadingState(false);
      }
    }} />
    </LegacyComponentContainer>;
};
export const LegacyPartner = ({
  id
}) => {
  const [project, setProject] = React.useState(null);
  const {
    adminProjectDetailStore,
    partnerStore
  } = useStores();
  React.useEffect(() => {
    getProjectDetail(`${id}`).then(res => {
      const project = {
        ...res,
        statusDetail: res.status,
        typeBatch: res.source
      };
      setProject(project);
    }).catch(console.error);
  }, [id]);
  if (!project) return null;
  return <LegacyComponentContainer>
      <ProjectPartner project={project} />
      <LegacyProjectDetailPartners query={{
      id
    }} adminProjectDetailStore={adminProjectDetailStore} partnerStore={partnerStore} />
    </LegacyComponentContainer>;
};
export const LegacyReports = ({
  id
}) => {
  //@ts-ignore
  return <LegacyComponentContainer>
      <Reports query={{
      id
    }} />
    </LegacyComponentContainer>;
};